import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { get_company_jobs_lists_action } from "../../../../redux/_actions";
import { useLocation, useNavigate } from "react-router-dom";

function useJobs(props) {
  const location = useLocation();
  const dispatch = useDispatch();
  const [companyJobs, setCompanyJobs] = useState({});

  const navigate = useNavigate();

  //get data from redux
  const { companyJobsListData } = useSelector(
    (state) => state.get_company_jobs_lists_reducer
  );

  useEffect(() => {
    const companyId = location?.state && location.state?.companyId;
    if (companyId) {
      getCompanyJobList(companyId);
    }
  }, []);

  useEffect(() => {
    if (companyJobsListData && companyJobsListData.data) {
      setCompanyJobs(companyJobsListData && companyJobsListData.data?.results);
    }
  }, [companyJobsListData]);


  const getCompanyJobList = (id) => {
    dispatch(get_company_jobs_lists_action(id));
  };
  const onJobApplyClick = (id) => {
    navigate(`/view-job-detail/${id}`);
  }

  return {
    companyJobs,
    onJobApplyClick
  };
}
export default useJobs;
